import DesktopOnlyView from "./DesktopOnlyView";

export default DesktopOnlyView;
